export default __webpack_public_path__ + "static/graph_vertical-f708b76fbd71ee431bb6b1ff714d5a51.svg";